import * as React from 'react';

const RequestPickupIcon = () => (
  <svg width={22} height={25} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 425 309" aria-label="Request pickup icon">
    <path
      d="M366.833 77.333h-57.875V.167H38.875C17.558.167.292 17.433.292 38.75v212.208h38.583c0 31.928 25.947 57.875 57.875 57.875s57.875-25.947 57.875-57.875h115.75c0 31.928 25.947 57.875 57.875 57.875s57.875-25.947 57.875-57.875h38.583V154.5l-57.875-77.167zM96.75 279.896c-16.012 0-28.938-12.926-28.938-28.938s12.926-28.937 28.938-28.937 28.938 12.925 28.938 28.937-12.926 28.938-28.938 28.938zM357.188 106.27l37.908 48.229h-86.138v-48.23h48.23zM328.25 279.896c-16.012 0-28.938-12.926-28.938-28.938s12.926-28.937 28.938-28.937 28.938 12.925 28.938 28.937-12.926 28.938-28.938 28.938z"
      fill="#000"
      fillRule="nonzero"
    />
  </svg>
);

export default RequestPickupIcon;
